import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

import { ShipmentFlat } from './basis-overlay.container';
import { TooltipType } from './basis-overlay-tooltip.directive';

@Component({
  selector: 'prlw-table-basis-overlay-ui',
  templateUrl: './basis-overlay.component.html',
  styleUrls: ['./basis-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisOverlayComponent implements AfterViewInit {
  @ViewChildren('contentRows') public contentRows!: QueryList<ElementRef>;
  @Input() public shipments!: ShipmentFlat[];
  @Output() public readonly addShipment = new EventEmitter<string>();
  @Output() public readonly addAllShipments = new EventEmitter<void>();
  public tooltipTypes: TooltipType[] = [];

  public ngAfterViewInit(): void {
    this.tooltipTypes = this.contentRows
      .toArray()
      .map((el) => this._setTooltipType(el));
  }

  public getTooltipType(index: number): TooltipType {
    return this.tooltipTypes[index] ?? null;
  }

  public add(shipmentCode: string, index: number): void {
    const isLast = Boolean(this.tooltipTypes.length === 1);
    if (isLast) {
      this.addAllShipments.emit();
      return;
    }
    this.tooltipTypes.splice(index, 1);
    this.addShipment.emit(shipmentCode);
  }

  public addAll(): void {
    this.addAllShipments.emit();
  }

  private _hasWidthOverflow(elem: HTMLElement): boolean {
    return elem.offsetWidth < elem.scrollWidth;
  }

  private _setTooltipType(elem: ElementRef): TooltipType {
    const isNameOverflow = this._hasWidthOverflow(
      elem.nativeElement.querySelector(':nth-child(2)'),
    );
    const isPlantOverflow = this._hasWidthOverflow(
      elem.nativeElement.querySelector(':nth-child(3)'),
    );

    let type = isNameOverflow && isPlantOverflow ? 'all' : null;
    type = !type && isNameOverflow ? 'name' : type;
    type = !type && isPlantOverflow ? 'plant' : type;

    return type as TooltipType;
  }
}
